import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initializeOpenTelemetry } from './instrumentation';
// Initialize OpenTelemetry before rendering
// Uses backend proxy at /otlp/traces to avoid CORS issues with Grafana Cloud
initializeOpenTelemetry();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
